import { render, staticRenderFns } from "./ApplicationCheckResult.vue?vue&type=template&id=505857d5&"
import script from "./ApplicationCheckResult.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCheckResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports